import React, { useRef, useEffect, useState } from "react";
import "./AboutUs.css";
import aboutImage from "../assets/OVEDND0.jpg"; // replace with your image

const AboutSection = () => {
  return (
    <section className="about-section-c" id="about">
      <h2 className="about-title">About Us</h2>

      <div className="about-top">
        <div className="about-image-wrapper">
          <img
            src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80"
            alt="Creative branding workspace"
            className="about-image"
          />
        </div>

        <div className="about-text">
          <p>
            {" "}
            We are a creative branding and media agency focused on helping
            businesses grow through strategic design, marketing, and
            storytelling.
          </p>
          <p>
            We are a creative branding and media agency focused on helping
            businesses grow through strategic design, marketing, and
            storytelling.
          </p>
          <p>
            Our mission is to craft experiences and content that connect with
            audiences and drive real results. With a diverse team and a
            forward-thinking approach, we turn ideas into impactful campaigns.
          </p>
        </div>
      </div>

      <div className="about-bottom">
        <div className="card vision-card">
          <div className="icon" aria-hidden="true">
            🎯
          </div>
          <h3>Vision</h3>
          <p>
            To be a leading media company serving the book publishing industry
            while also empowering businesses with impactful branding,
            advertising, and digital media solutions.
          </p>
        </div>

        <div className="card mission-card">
          <div className="icon" aria-hidden="true">
            🚀
          </div>
          <h3>Mission</h3>
          <p>
            At UV Media, our mission is to support publishers, educators, and
            business owners by providing end-to-end content creation,
            professional design, video production, and marketing services. We
            aim to combine creativity, quality, and technology to deliver
            compelling media that educates, engages, and elevates brands.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
